<template>
  <v-container>
    <QuestsProgressLinear></QuestsProgressLinear>
    <v-spacer></v-spacer>
    <GenericChecklist @complete="complete" @uncomplete="uncomplete" :headers="[{text:'completed', value:'completed'},{text:'quest', value:'name'},{text:'level', value:'level'}]" :items="filtered" :itemKey="'id'"></GenericChecklist>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex"

import GenericChecklist from '@/components/GenericChecklist'
import QuestsProgressLinear from "@/components/QuestsProgressLinear";


export default {
  name: "Quests",
  components: { QuestsProgressLinear, GenericChecklist },
  computed: {
    ...mapGetters("entities/quests",["filtered"])
  },
  methods: {
    ...mapActions("entities/quests", ["complete", "uncomplete"]),
  },
};
</script>
